module.exports = __webpack_public_path__ + "img/num_36.5417de45.png";